import smile from '../assets/icons/smile.png'
import cup from '../assets/icons/cup.png'
import meter from '../assets/icons/meter.png'
import dollar from '../assets/icons/dollar.png'
import like from '../assets/icons/like.png'
import user from '../assets/icons/user.png'

const homecard = [
    {
        img : smile,
        title : 'Human forces',
        para: 'Human forces shift towards more value-adding and rewarding activities'
    },
    {
        img : cup,
        title : 'Acceleration of human',
        para: 'The unprecendented acceleration of human achievements results in higher motivation and effiency'
    },
    {
        img : meter,
        title : 'Routine business',
        para: 'Routine business processes are performed faster, become more predictable and less prone to human error'
    },
    {
        img : dollar,
        title : 'The reduction',
        para: 'The reduction of operating costs is directly reflected in higher revenue and more competitive prices'
    },
    {
        img : like,
        title : 'Higher quality',
        para: 'Higher quality and more accountabilty ensures your business a competitve edge'
    },
    {
        img : user,
        title : 'Human contact',
        para: 'Minimized human contact with sensitive data improves security and control levels within manufacturing and operaitonal processes'
    }
]

export default homecard;